import Service from "../../Services/index";

const machine = {
    namespaced: true,
    state: {
        data: [],
        machine_sheet : [],
    },
    mutations: {
        GET_MACHINE: (state, res) => {
            state.data = res;
        },
        GET_MACHINE_SHEET: (state, data) => {
            state.machine_sheet = data;
        },
    },
    actions: {
        get({ commit }) {
            return Service.machine.getMachine().then(response => {
                commit("GET_MACHINE", response);
            });
        },
        getMachineSheet({commit}){
            return Service.machine.getMachineSheet().then(response=>{
                commit("GET_MACHINE_SHEET",response)
            })
        }
    }
};
export default machine;
